import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";
import {
  addProductStyleAsync,
  addProductChargeBackTypeAsync,
  deleteProductChargeBackTypeAsync,
  editProductStyleAsync,
  editProductChargeBackTypeAsync,
  getProductStyleAsync,
  getProductChargeBackTypeAsync,
} from "../../../../store/services/productInfoServices";
const ChargeBackType = () => {
  const dispatch = useDispatch();
  const {
    getProductChargeBackTypeStatus,
    getProductChargeBackTypeError,
    getProductChargeBackTypeData,
    addProductChargeBackTypeStatus,
    addProductChargeBackTypeData,
    addProductChargeBackTypeError,

    editProductChargeBackTypeStatus,
    editProductChargeBackTypeError,
    editProductChargeBackTypeData,

    deleteProductChargeBackTypeData,
    deleteProductChargeBackTypeStatus,
    deleteProductChargeBackTypeError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductChargeBackTypeAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductChargeBackTypeData?.length
    ? getProductChargeBackTypeData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedChargeBackType, setSelectedChargeBackType] = useState();
  const [addChargeBackTypeMode, setAddChargeBackTypeMode] = useState(false);
  const [addChargeBackTypeData, setAddChargeBackTypeData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedChargeBackType", selectedChargeBackType);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductChargeBackTypeStatus === asyncStatus.SUCCEEDED) {
      setAddChargeBackTypeMode(false);
      setSaveDisabled(true);
      setAddChargeBackTypeData();
    }
  }, [, addProductChargeBackTypeStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductChargeBackTypeAsync(selectedChargeBackType?.charge_back_type_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductChargeBackTypeStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedChargeBackType();
    }
  }, [, deleteProductChargeBackTypeStatus]);
  useEffect(() => {
    if (editProductChargeBackTypeStatus === asyncStatus.SUCCEEDED) {
      setSelectedChargeBackType();
      setEditMode(false);
    }
  }, [, editProductChargeBackTypeStatus]);
console.log("getProductChargeBackTypeData",getProductChargeBackTypeData,editProductChargeBackTypeData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this Charge Back Type?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Charge Back Type"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Charge Back Type Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddChargeBackTypeMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addChargeBackTypeMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addChargeBackTypeMode || !selectedChargeBackType}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddChargeBackTypeMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addChargeBackTypeMode || !selectedChargeBackType}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductChargeBackTypeStatus === asyncStatus.LOADING ||
                  editProductChargeBackTypeStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addChargeBackTypeData) {
                    dispatch(addProductChargeBackTypeAsync(addChargeBackTypeData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedChargeBackType, ...editData };
                    delete a.id;
                    dispatch(editProductChargeBackTypeAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "charge_back_type_id", headerName: "ID", flex: true },
                  {
                    field: "charge_back_type",
                    headerName: "Charge Back Type Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedChargeBackType(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductChargeBackTypeStatus === asyncStatus.IDLE ||
                  getProductChargeBackTypeStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addChargeBackTypeMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Charge Back Type:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddChargeBackTypeData({
                            ...addChargeBackTypeData,
                            charge_back_type: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddChargeBackTypeData({
                            ...addChargeBackTypeData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedChargeBackType ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedChargeBackType?.charge_back_type_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "ChargeBackType:",
                    comp: (
                      <InputComp
                        key={selectedChargeBackType?.charge_back_type_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            charge_back_type: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedChargeBackType?.charge_back_type}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedChargeBackType?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedChargeBackType?.is_active ? true : false
                        }
                        checked={selectedChargeBackType?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any Charge Back Type</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductChargeBackTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductChargeBackTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductChargeBackTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductChargeBackTypeError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedChargeBackType(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedChargeBackType(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default ChargeBackType;
